module.exports = __webpack_public_path__ + "img/141.d893b018.png";